import { useCallback, useId, useState } from "react";
import { SearchBarRoot } from "./PortalSearchBar.styles";

const SearchIcon = ({ color }) => (
  <svg
    className="portal-search-icon"
    width="24"
    height="24"
    fill="none"
    stroke={color}
    viewBox="0 0 24 24"
    aria-hidden
  >
    <circle cx="11" cy="11" r="6" strokeWidth="1" />
    <line x1="21" y1="21" x2="15" y2="15" strokeWidth="1" />
  </svg>
);

const ClearIcon = () => (
  <svg width="16" height="16" fill="none" stroke="#757575" viewBox="0 0 24 24" aria-hidden>
    <line x1="18" y1="6" x2="6" y2="18" strokeWidth="2" />
    <line x1="6" y1="6" x2="18" y2="18" strokeWidth="2" />
  </svg>
);

const PortalSearchBar = ({
  value,
  onChange,
  placeholder = "Search",
  className,
  style,
  maxWidth,
  marginBottom,
  marginTop,
  autoFocus,
}) => {
  const inputId = useId();
  const [iconColor, setIconColor] = useState("#757575");

  const makeActive = useCallback(() => setIconColor("#2251FF"), []);
  const makeInactive = useCallback(() => setIconColor("#757575"), []);

  const clearInput = () => {
    onChange({ target: { value: "" } });
  };

  return (
    <SearchBarRoot
      className={className}
      style={style}
      $maxWidth={maxWidth}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
    >
      <label htmlFor={inputId}>
        <input
          id={inputId}
          type="search"
          placeholder={placeholder}
          value={value}
          onFocus={makeActive}
          onBlur={makeInactive}
          onMouseOver={makeActive}
          onMouseOut={makeInactive}
          onChange={onChange}
          autoComplete="off"
          autoFocus={autoFocus}
        />
        {!value ? <SearchIcon color={iconColor} /> : null}
      </label>
      {value ? (
        <button type="button" className="portal-search-clear" onClick={clearInput} aria-label="Clear search">
          <ClearIcon />
        </button>
      ) : null}
    </SearchBarRoot>
  );
};

export default PortalSearchBar;
